export default __webpack_public_path__ + "static/media/receptors_2.72708203.svg";